import React from 'react';
import { Block, FullWidthImage } from './content';
const ImagePreview = ({
  src
}) => {
  return /*#__PURE__*/React.createElement(Block, {
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(FullWidthImage, {
    src: src
  }));
};
export { ImagePreview };